import { BasicAPI } from '../../core-apis/src/apis/config/api/basicApi'

const apiUrl = process.env.HEXA_URL_API ?? ''
const servicesApiUrl = `${apiUrl}`
class HexaServiceAPI extends BasicAPI {
  constructor() {
    super({
      domain: servicesApiUrl
    })
  }
}

export const hexaServiceAPI = new HexaServiceAPI()
